import { FunctionComponent } from "react";
import OptionBox from "./OptionBox";
import ListItem from "../ListItem/ListItem";
import Button from "../Button/Button";
import { FormData } from "../form-data";
import { ComponentOption, PageOption } from "../../../lib/ssi/form.types";
import { ValidateResultInline } from "../../../lib/validations/validate";

type OptionBoxesProps = {
  data: PageOption;
  onDataSelected: (data: FormData) => void;
  onBack?: () => void;
  resolveExpression: (expression: string) => unknown;
  errors: { [key: string]: ValidateResultInline };
  nextPage?: string;
  isLoading?: boolean;
};

const OptionBoxes: FunctionComponent<OptionBoxesProps> = ({
  data,
  onDataSelected,
  onBack,
  resolveExpression,
  isLoading,
}) => {
  const content: JSX.Element[] = [];

  const visibleComponents: ComponentOption[] = [];
  data.components.forEach((el) => {
    if (el.condition && !resolveExpression(el.condition)) {
      return;
    }
  
    visibleComponents.push(el);
  });

  const dcl = visibleComponents.length;
  const isMultipleThree = dcl ? dcl % 3 === 0 : false;
  const isOnlyOne = dcl === 1;
  const width = isMultipleThree ? "lg:w-1/3" : (isOnlyOne ? "lg:w-1/1" : "lg:w-1/2");
  const padding = isMultipleThree ? "lg:px-3" : "lg:px-6";

  visibleComponents.forEach((el) => {
    return (content[el.index] = (
      <div className={`px-2 py-2 w-full lg:py-0 ${padding} ${width} mb-12`} key={el.id}>
        <OptionBox
          {...el}
          onSelect={onDataSelected}
          questionId={data.id}
          isLoading={isLoading}
        >
          {el.list.map((listItem, index) => (
            <ListItem
              icon={listItem.icon}
              key={listItem.id}
              last={index === el.list.length - 1}
            >
              {listItem.label}
            </ListItem>
          ))}
        </OptionBox>
      </div>
    ));
  });
  return (
    <div>
      <div className="flex flex-wrap items-stretch">
        {content}
      </div>
      {onBack ? (
        <div className="flex flex-wrap justify-center">
          <Button variant="text" onPress={() => onBack()}>
            Zurück
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default OptionBoxes;
